import { getLuminance } from 'polished';

import { token } from '@atlaskit/tokens';
import { fireErrorAnalytics } from '@atlassian/error-handling';

import { toHexColor } from '../../color-conversion';

/**
 * Determines the appropriate text color (dark or light) based on the background color's luminance.
 * Uses polished's getLuminance which requires HEX colors, so converts input if needed.
 *
 * @param color - The background color to evaluate
 * @param packageName - The package name for error analytics tracking
 * @returns A design token for either dark text (color.text) or light text (color.text.inverse)
 */
export const readableTextColor = (color: string, packageName: string): string => {
	try {
		// Convert to HEX as polished's getLuminance only accepts HEX colors
		const hexColor = toHexColor(color);
		return getLuminance(hexColor) > 0.5 ? token('color.text') : token('color.text.inverse');
	} catch (error) {
		fireErrorAnalytics({
			error:
				error instanceof Error
					? error
					: new Error(`Color luminance calculation failed for color: ${color}`),
			meta: {
				id: 'readableTextColor',
				packageName,
			},
		});
		// Fallback to text color
		return token('color.text');
	}
};
